module.exports = __webpack_public_path__ + "img/2.da08f4a4.png";